import moment from "moment-timezone";

const PARIS = "Europe/Paris";
const at = (date) => moment.tz(date, "YYYY-MM-DD HH:mm:ss", PARIS);

// Jours pleins restants avant une échéance de l'événement (0 : c'est aujourd'hui).
export const daysUntil = (date) => Math.max(0, at(date).startOf("day").diff(moment().tz(PARIS).startOf("day"), "days"));

// « 19 octobre » ou « October 19 ».
export const eventDay = (date, locale) => at(date).locale(locale).format(locale === "fr" ? "Do MMMM" : "MMMM D");

// La phrase qui dit où en est l'événement, à passer à t().
export function phaseLabel(event, locale) {
    if (event.phase === "upcoming") return ["avatar_event_upcoming", { date: eventDay(event.from, locale) }];
    if (event.phase === "open") return ["avatar_event_days_left", { days: daysUntil(event.to) }];
    if (event.phase === "last_chance") return ["avatar_event_last_chance", { days: daysUntil(event.lastChanceTo) }];
    return ["avatar_event_closed", {}];
}
